import { useRouter } from 'next/router';
import { useState } from 'react';

import { FILTER_ENUMS } from 'search/enums/constants';
import { IConstructorFacetMultiple } from 'shared/types/ConstructorFacet';
import { SearchFilterCategoryDesktop } from 'search/components/searchGrid/SearchFilterCategoryDesktop';
import { SearchFilterColorDesktop } from 'search/components/searchGrid/SearchFilterColorDesktop';
import { SearchFilterConditionDesktop } from 'search/components/searchGrid/SearchFilterConditionDesktop';
import { SearchFilterGrid } from 'search/components/searchGrid/SearchFilterGrid';
import { SearchFilterList } from 'search/components/searchGrid/SearchFilterList';
import { SearchFilterSizeDesktop } from 'search/components/searchGrid/SearchFilterSizeDesktop';
import {
  SearchFilterDesktopTitle,
  SearchFilterDesktopCollapsible,
} from 'search/styles/SearchStyles';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useEventContext } from 'tracking/hooks/useEventContext';
import { useIsCrawler } from 'shared/hooks/useIsCrawler';
import { getConstructorCategoriesStrings } from 'search/enums/translations';

const FILTER_TYPE = {
  [FILTER_ENUMS.BRAND]: SearchFilterList,
  [FILTER_ENUMS.CATEGORY]: SearchFilterCategoryDesktop,
  [FILTER_ENUMS.COLOR]: SearchFilterColorDesktop,
  [FILTER_ENUMS.CONDITION]: SearchFilterConditionDesktop,
  [FILTER_ENUMS.GENDER]: SearchFilterList,
  [FILTER_ENUMS.SIZE]: SearchFilterSizeDesktop,
  [FILTER_ENUMS.YEAR]: SearchFilterGrid,
};

interface ISearchFilterDesktop {
  facet: IConstructorFacetMultiple;
  isFilterExpanded?: boolean;
  resultIds: Array<string>;
  scrollable?: boolean;
  topLevelCategory?: string;
  isCrawler?: boolean;
}

export const SearchFilterDesktop = ({
  facet,
  isFilterExpanded = false,
  resultIds,
  topLevelCategory,
  scrollable = false,
  isCrawler = false,
}: ISearchFilterDesktop) => {
  const [isFilterOpen, setIsFilterOpen] = useState(isFilterExpanded);
  const filterOptions = facet?.options;
  const hasFilterApplied = filterOptions.some((option) => option.status === 'selected');
  const FilterComponent = FILTER_TYPE[facet.name];
  const eventTrackingEventContext = useEventContext();
  const {
    query: { query: searchQuery },
  } = useRouter();
  const { doNotCrawlPaths } = useIsCrawler();

  const handleOnClick = () => {
    setIsFilterOpen((prevState) => !prevState);

    if (!isFilterOpen) {
      sendTrackingEvent('FILTER_EXPAND_TAP', {
        event_context: eventTrackingEventContext,
        filter_name: facet.name,
        ...(searchQuery && { search_string: searchQuery?.toString() }),
      });
    }
  };
  return (
    <>
      <SearchFilterDesktopTitle
        data-qa={`${facet?.display_name.toLowerCase()}_filter_option`}
        onClick={handleOnClick}
        isFilterOpen={isFilterOpen}
        hasFilterApplied={hasFilterApplied}
      >
        {getConstructorCategoriesStrings(facet?.display_name)}
      </SearchFilterDesktopTitle>

      {isCrawler && !doNotCrawlPaths ? (
        <SearchFilterDesktopCollapsible
          scrollable={scrollable}
          isFilterOpen={isFilterOpen}
          isCrawler={isCrawler}
        >
          <FilterComponent
            filterOptions={filterOptions}
            facetType={facet.name}
            resultIds={resultIds}
            topLevelCategory={topLevelCategory}
            isCrawler={isCrawler}
          />
        </SearchFilterDesktopCollapsible>
      ) : (
        isFilterOpen && (
          <SearchFilterDesktopCollapsible scrollable={scrollable}>
            <FilterComponent
              filterOptions={filterOptions}
              facetType={facet.name}
              resultIds={resultIds}
              topLevelCategory={topLevelCategory}
            />
          </SearchFilterDesktopCollapsible>
        )
      )}
    </>
  );
};
